import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-primary-700 via-primary-800 to-primary-900 text-white">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Coluna 1 - Sobre */}
          <div className="col-span-2 sm:col-span-2 md:col-span-3 lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/d59a2823757fedf9fab30970c772cc93/fc97616593fadb8f9287babe64f21a28.png" 
              alt="TG WEB" 
              className="h-8 sm:h-10 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-neutral-200 text-sm leading-relaxed mb-4 max-w-sm">
              A gestão inteligente que sua transportadora precisa. Sistema completo para emissão de CT-e, MDF-e, controle financeiro e gestão de frota 100% na nuvem.
            </p>
            <div className="flex space-x-3">
              <a href="#" rel="nofollow" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-base sm:text-lg"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Coluna 2 - Funcionalidades */}
          <div>
            <h4 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4">
              <Link to="/funcionalidades" className="hover:text-secondary transition-colors">
                Funcionalidades
              </Link>
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/funcionalidades/cte-mdfe" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Emissão de CT-e e MDF-e
                </Link>
              </li>
              <li>
                <Link to="/funcionalidades/financeiro" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Controle Financeiro
                </Link>
              </li>
              <li>
                <Link to="/funcionalidades/estoque" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Gestão de Estoque
                </Link>
              </li>
              <li>
                <Link to="/funcionalidades/motorista" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Cadastro de Motoristas
                </Link>
              </li>
              <li>
                <Link to="/funcionalidades/relatorios" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Relatórios Gerenciais
                </Link>
              </li>
              <li>
                <Link to="/sistema-emissao-cte" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Emissor de CT-e Online
                </Link>
              </li>
            </ul>
          </div>

          {/* Coluna 3 - Recursos */}
          <div>
            <h4 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4">Recursos</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/planos" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Planos e Preços
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Perguntas Frequentes
                </Link>
              </li>
              <li>
                <Link to="/sitemap" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Mapa do Site
                </Link>
              </li>
              <li>
                <a href="#" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Central de Ajuda
                </a>
              </li>
              <li>
                <a href="#" className="text-neutral-200 hover:text-white transition-colors text-xs sm:text-sm">
                  Atualizações
                </a>
              </li>
            </ul>
          </div>

          {/* Coluna 4 - Contato */}
          <div className="col-span-2 sm:col-span-1">
            <h4 className="font-semibold text-base sm:text-lg mb-3 sm:mb-4">Contato</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-secondary mt-0.5 sm:mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-xs sm:text-sm text-neutral-200">Telefone</p>
                  <a href="tel:+553530420478" className="text-xs sm:text-sm font-medium hover:text-secondary transition-colors">
                    (35) 3042-0478
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-secondary mt-0.5 sm:mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-xs sm:text-sm text-neutral-200">Email</p>
                  <a href="mailto:comercial@telluria.com.br" className="text-xs sm:text-sm font-medium hover:text-secondary transition-colors break-all">
                    comercial@telluria.com.br
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-whatsapp-line text-secondary mt-0.5 sm:mt-1 flex-shrink-0"></i>
                <div>
                  <p className="text-xs sm:text-sm text-neutral-200">WhatsApp</p>
                  <a 
                    href="https://wa.me/5535998093635" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-xs sm:text-sm font-medium hover:text-secondary transition-colors cursor-pointer"
                  >
                    (35) 99809-3635
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Links Rápidos SEO */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-white/10">
          <div className="flex flex-wrap gap-x-4 gap-y-2 sm:gap-x-6 justify-center text-xs sm:text-sm text-neutral-300">
            <Link to="/" className="hover:text-white transition-colors">Sistema para Transportadora</Link>
            <Link to="/sistema-emissao-cte" className="hover:text-white transition-colors">Emissor de CT-e</Link>
            <Link to="/funcionalidades/cte-mdfe" className="hover:text-white transition-colors">Emissão de MDF-e</Link>
            <Link to="/funcionalidades" className="hover:text-white transition-colors">Software de Gestão</Link>
            <Link to="/planos" className="hover:text-white transition-colors">Transportadora Pequena</Link>
            <Link to="/funcionalidades/relatorios" className="hover:text-white transition-colors">Gestão de Frota</Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-xs sm:text-sm text-neutral-300 text-center sm:text-left">
              © {currentYear} TG WEB. Todos os direitos reservados.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
              <a href="#" className="text-xs sm:text-sm text-neutral-300 hover:text-white transition-colors">
                Política de Privacidade
              </a>
              <a href="#" className="text-xs sm:text-sm text-neutral-300 hover:text-white transition-colors">
                Termos de Uso
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs sm:text-sm text-neutral-300 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
